import React, { useEffect, useState } from 'react';
import './App.css';
import NavBar from './components/NavBar';
import Hero from './components/Hero';
import ProductsGrid from './components/ProductsGrid';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

import categories from './data/categories';
import products from './data/products';
import testimonialsData from './data/testimonials';
import api from './services/api';

function App() {
  const [isDark, setIsDark] = useState(false);
  const [cart, setCart] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('всі');
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonialsData.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const addToCart = async (product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    try {
      await api.addToCart(product.id, 1);
    } catch (e) {
      // noop: keep optimistic UI
      // console.error(e);
    }
  };

  const toggleFavorite = async (productId) => {
    setFavorites((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
    try {
      await api.toggleFavorite(productId);
    } catch (e) {
      // revert on failure
      setFavorites((prev) =>
        prev.includes(productId)
          ? prev.filter((id) => id !== productId)
          : [...prev, productId]
      );
    }
  };

  return (
    <div
      className={`min-h-screen transition-all duration-500 ${
        isDark
          ? 'bg-gray-900 text-white'
          : 'bg-gradient-to-br from-yellow-50 via-pink-50 to-violet-50 text-gray-900'
      }`}
    >
      <NavBar
        isDark={isDark}
        favoritesCount={favorites.length}
        cartCount={cart.reduce((sum, item) => sum + item.quantity, 0)}
        onToggleTheme={() => setIsDark(!isDark)}
      />

      <Hero isDark={isDark} />
      <ProductsGrid
        isDark={isDark}
        categories={categories}
        products={products}
        searchQuery={searchQuery}
        activeCategory={activeCategory}
        favorites={favorites}
        onSearch={setSearchQuery}
        onChangeCategory={setActiveCategory}
        onToggleFavorite={toggleFavorite}
        onAddToCart={addToCart}
      />
      <Testimonials
        isDark={isDark}
        testimonials={testimonialsData}
        currentSlide={currentSlide}
        setCurrentSlide={setCurrentSlide}
      />
      <Contact isDark={isDark} />
      <Footer isDark={isDark} />
    </div>
  );
}

export default App;
